import React, { useState, useContext, useEffect, useRef } from 'react';
import { AuthContext } from 'context/AuthContext';
import { config } from 'utils/config';
import { LoadingSpinner } from 'components/LoadingSpinner/LoadingSpinner';
import { navigate } from 'gatsby';
import { apiLoginGoogle } from 'utils/api';
import { urls } from 'utils/urls';

import * as styles from './g-sign-in.module.css';

const errMsg = 'An error occurred while attempting to login via your Google account.';

export const GoogleSignup = () => {
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isInitialized, setIsInitialized] = useState(false);
  const [googleRetries, setGoogleRetries] = useState(0);
  const { setLogin } = useContext(AuthContext);
  const gButtonRef = useRef(null);

  useEffect(() => {
    if (window?.google && gButtonRef.current && !isInitialized) {
      const handleCallback = ({ credential, select_by }) => {
        setLoading(true);

        const fd = new FormData();
        fd.append('access_token', credential);
        fd.append('select_by', select_by);

        apiLoginGoogle(fd)
          .then((user) => {
            setLogin(user);
          })
          .catch((err) => {
            if (err?.data?.totp) return navigate(urls.accounts.login_2fa);
            if (err?.data?.sms) return navigate(urls.accounts.login_2fa_sms);
            setError(err?.data?.code?.[0] || err?.data?.non_field_errors?.[0] || errMsg);
            setLoading(false);
          });
      };
      window.google.accounts.id.initialize({
        client_id: config.googleClientID,
        callback: handleCallback,
      });

      window.google.accounts.id.prompt();
      window.google.accounts.id.renderButton(gButtonRef.current, {
        type: 'standard',
        shape: 'pill',
        theme: 'outline',
        text: 'continue_with',
        size: 'large',
        logo_alignment: 'left',
      });
      setIsInitialized(true);
    }
    if (!window?.google) {
      setTimeout(
        () =>
          setGoogleRetries((old) => {
            return old + 1;
          }),
        1000,
      );
    }
  }, [isInitialized, gButtonRef, setLogin, googleRetries]);

  return (
    <div className={styles.googleWrapper}>
      {error && <p className={styles.error}>{error}</p>}
      {isLoading ? (
        <LoadingSpinner color='blue' />
      ) : (
        <>
          {!isInitialized && <LoadingSpinner color='blue' />}
          <div
            ref={gButtonRef}
            // className='g_id_signin'
            // data-type='standard'
            // data-shape='pill'
            // data-theme='outline'
            // data-text='continue_with'
            // data-size='large'
            // data-logo_alignment='left'
          ></div>
        </>
      )}
    </div>
  );
};
